export default __webpack_public_path__ + "static/media/Group 4941.51323e02.png";